// extracted by mini-css-extract-plugin
export default {"heading":"heading-bxBol","filters":"filters-tG8CT","error":"error-E9Ns3","yearlyStats":"yearlyStats-CljRx","monthlyStats":"monthlyStats-xUc6t"};